import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private apiService: ApiService) {}

  getCode(data: string, type: 'Phone' | 'Email' | string) {
    return this.apiService.get(`/api/Account/SendCode?${type}=` + data);
  }

  registration(data) {
    return this.apiService.post(`/api/Account/RegisterCustomer`, data);
  }

  loginCode(data) {
    return this.apiService.post(`/api/Account/Login`, data);
  }

  renewAuth() {
    let body = {
      accessToken: String(localStorage.getItem('access_token')),
      refreshToken: String(localStorage.getItem('refresh_token')),
    };
    return this.apiService.post3(`/api/Account/RefreshToken`, body);
  }

  isAuthenticated(): boolean {
    const token = localStorage.getItem('access_token');
    return token !== null && token !== undefined;
  }
}
